import { createRoot } from "react-dom/client";
import { Suspense } from "@remhealth/core";
import { lazy } from "@remhealth/ui";
import "./theme.scss";

const App = lazy(() => import("./app"));

const root = createRoot(document.getElementById("root")!);
root.render(
  <Suspense minimal>
    <App />
  </Suspense>
);
